export default "__VITE_ASSET__Bgmadqo0__"